import { makeAutoObservable } from "mobx";

export default class SwitchSiteStore {
  selectedSiteOption = null;

  constructor() {
    makeAutoObservable(this);
  }

  get sites() {
    let sites = [];
    if (sessionStorage.sites) {
      sites = JSON.parse(sessionStorage.sites);
    }
    return sites;
  }

  get siteOptions() {
    const currentUrl = window.location.href.split("#")[0];
    return this.sites.map((site, i) => ({
      ...site,
      label: site.name,
      value: i,
      disabled: !site.webAppURL || site?.webAppURL?.includes(currentUrl),
    }));
  }

  goToSelectedSite() {
    if (this.selectedSiteOption) {
      window.location.href = `${this.selectedSiteOption.webAppURL}`;
    }
  }
}
